/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React, { PropTypes, Component } from 'react';
import styles from './App.css';
import withContext from '../../decorators/withContext';
import withStyles from '../../decorators/withStyles';
import Header from '../Header';
import Footer from '../Footer';
import LoadingSpinner from '../LoadingSpinner';
import GlobalStore from '../../stores/Global';

@withContext
@withStyles(styles)
class App extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    error: PropTypes.object
  };

  constructor(props) {
    super(props);
    this._globalChange = this._globalChange.bind(this);

    this.state = GlobalStore.get();
  }

  componentDidMount() {
    GlobalStore.addChangeListener(this._globalChange);
  }

  componentWillUnmount() {
    GlobalStore.removeChangeListener(this._globalChange);
  }

  _globalChange() {
    this.setState(GlobalStore.get()); // eslint-disable-line react/no-set-state
  }

  render() {
    return !this.props.error ? (
      <div>
        <LoadingSpinner {...this.state.loading} />
        <Header />
        <div className="container">
          {this.props.children &&
            React.cloneElement(this.props.children, {
              steps: this.state.steps,
              gallery: this.state.gallery
            })
          }
        </div>
        <Footer />
      </div>
    ) : this.props.children;
  }

}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App/App.js
 **/